import { render, staticRenderFns } from "./NewPurchaseOrder.vue?vue&type=template&id=52c0d979&"
import script from "./NewPurchaseOrder.vue?vue&type=script&lang=js&"
export * from "./NewPurchaseOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports